export default "__VITE_ASSET__OOfq8fDOe4llJwFUg47j2g__"